import type { CSSObject } from 'styled-components';

const DOTTED_UNDERLINE_STYLES: CSSObject = {
  textDecorationStyle: 'dotted',
  textDecorationSkipInk: 'none',
  textDecorationThickness: '10%',
  textUnderlineOffset: '20%',
};

export { DOTTED_UNDERLINE_STYLES };
